export default __webpack_public_path__ + "c7a96b4d694a533954bef848936c58de.png";